// src/redux/slices/redirectionSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = '/api/v1/redirection';

// Async thunk with page and filters
export const fetchRedirections = createAsyncThunk(
  'redirection/fetch',
  async ({ page = 1, filters = {} }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ page });

      // Append filters
      for (const key in filters) {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      }

      const response = await axios.get(`${BASE_URL}/get-redirection?${params.toString()}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const createRedirection = createAsyncThunk(
  'redirection/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/create-redirection`, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateRedirection = createAsyncThunk(
  'redirection/update',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${BASE_URL}/update-redirection/${id}`, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteRedirection = createAsyncThunk(
  'redirection/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${BASE_URL}/delete-redirection/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const redirectionSlice = createSlice({
  name: 'redirection',
  initialState: {
  data: [],
  loading: false,
  error: null,
  totalPages: 1,
  totalItems: 0,  // 👈 Add this
  filters: {},
  page: 1
},
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // FETCH
     .addCase(fetchRedirections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRedirections.fulfilled, (state, action) => {
  state.loading = false;
  state.data = action.payload.data;
  state.totalPages = action.payload.totalPages;
  state.totalItems = action.payload.totalItems;  // ✅ Important
})

      .addCase(fetchRedirections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // CREATE
      .addCase(createRedirection.fulfilled, (state, action) => {
        state.data.unshift(action.payload);
        state.totalItems += 1;
      })
      // UPDATE
      .addCase(updateRedirection.fulfilled, (state, action) => {
        const index = state.data.findIndex((r) => r.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
      })
      // DELETE
      .addCase(deleteRedirection.fulfilled, (state, action) => {
        state.data = state.data.filter((r) => r.id !== action.payload);
        state.totalItems -= 1;
      });
  },
});
export const { setFilters, setPage } = redirectionSlice.actions;
export default redirectionSlice.reducer;
